import { BaseApiClient } from './BaseApiClient';
import { IApiInterface } from './IApiConfig';
import { IAuthTokenBuilder } from './IAuthTokenBuilder';

export class AlertsServiceClient extends BaseApiClient {
    public constructor(config: IApiInterface, fetch: any, authTokenBuilder: IAuthTokenBuilder,
                       googleAnalytics?: any) {
        super(config, fetch, authTokenBuilder, googleAnalytics);
    }

    public requireAssistance = async (gymName: string, userId?: string) => {
        const result = await this.fetch(`${this.config.LOCAL_SERVER_BASE_URL}/alerts/assistance`, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify({
                userId,
                gymName,
            }),
        });

        const responseJson = await result.json();
        if (result.status > 200) {
            throw new Error(responseJson.message);
        }
        return responseJson;
    }
    public firstTimeSigninAlert = async (userId: string, gymName: string) => {
        const result = await this.fetch(`${this.config.LOCAL_SERVER_BASE_URL}/alerts/firsttimer`, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify({
                userId,
                gymName,
            }),
        });
        const responseJson = await result.json();
        if (result.status > 200) {
            throw new Error(responseJson.message);
        }

        return responseJson;
    }
}
